import React from 'react';
import { connect } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { Container } from '../styled';
import Nav from 'components/nav';
import Footer from 'components/footer';

const Layout = (props) => {
    const history = useNavigate();

    return (
        <Container className="min-h-[90%] flex flex-col justify-between">
         

            {/* Main Content */}
            <div className="flex-grow justify-center">
                {props.children}
            </div>

            {/* Footer */}
            <Footer />
        </Container>
    );
};

const mapStateToProps = (state) => {
    return {
        appLoading: state.app.appLoading || {},
    };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(Layout);